import { jsx as _jsx } from "react/jsx-runtime";
// i18n/index.tsx
import { createContext, useContext, useMemo, useState, useEffect, } from "react";
import { getDict } from "./config";
const I18nContext = createContext(null);
export function I18nProvider({ initial = "it", children, }) {
    const [lang, setLang] = useState(initial);
    // Dizionari caricati dalla globale una sola volta
    const dictMap = useMemo(() => getDict(), []);
    useEffect(() => {
        const saved = localStorage.getItem("lang") || initial;
        if (saved !== lang)
            setLang(saved);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initial]);
    useEffect(() => {
        localStorage.setItem("lang", lang);
        document.documentElement.lang = lang; // per SEO/accessibilità
    }, [lang]);
    const value = useMemo(() => {
        var _a;
        return ({
            t: (_a = dictMap[lang]) !== null && _a !== void 0 ? _a : dictMap.it,
            lang,
            setLang,
        });
    }, [dictMap, lang]);
    return _jsx(I18nContext.Provider, { value: value, children: children });
}
export const useI18n = () => {
    const ctx = useContext(I18nContext);
    if (!ctx)
        throw new Error("useI18n must be used within I18nProvider");
    return ctx;
};
